import { CpatFaqs } from "features/Cpat/CpatOverview/Faqs"

import CpatResultBanner from "../CpatDashboard/CpatCompletedDashboard/CpatResultBanner"
import CpatPreviousReports from "./CpatPreviousReports"

const CpatReport = () => {
  return (
    <div className="flex flex-col">
      <CpatResultBanner />
      <CpatPreviousReports />
      <CpatFaqs assessmentCompleted={true} />
    </div>
  )
}

export default CpatReport
